
import styles from "./Loading.module.css";
import { Spinner } from '@chakra-ui/react'

//needs a prop called loading to render
const Loading = ({ loading, inline = false }) => {
  if (!loading) {
    return null
  }
  // console.log("loading");
  return (
    <div className={inline ? styles.inline : styles.fullScreen}>
      <Spinner thickness='4px'
        speed='0.65s'
        emptyColor='gray.200'
        color='blue.500'
        size='xl' />
    </div>
  );
};

export default Loading;
